import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Icon } from '@calendly/ui/components/icon';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTitle } from 'actions/home_bar/scope_dropdown';
import { useHomeTabs } from 'hooks/home/tabs';
import { titleSelector } from 'selectors/home_bar';
const titleCss = "t1xon4mg";
const Title = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(titleCss, props.className)} />);
const textCropCss = "t6xlwr6";
const TextCrop = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textCropCss, props.className)} />;
});
const ControlContent = () => {
  const title = useSelector(titleSelector);
  if (!title) return <Loader role="status" aria-label={I18n.t('publisher.messages.loading')} />;
  return <TextCrop>
      <BodyText>{title}</BodyText>
    </TextCrop>;
};
const ScopeDropdownControl = ({
  onClick,
  isExpanded,
  ...props
}) => {
  const dispatch = useDispatch();
  const title = useSelector(titleSelector);
  const {
    getTabScopeV1
  } = useHomeTabs();
  const {
    type,
    id
  } = getTabScopeV1();
  useEffect(() => {
    dispatch(loadTitle(type, id));
  }, [dispatch, type, id]);
  return <Title onClick={onClick} disabled={!title} {...props}>
      <ControlContent />
      <Icon name={isExpanded ? 'angle-up' : 'angle-down'} />
    </Title>;
};
export default ScopeDropdownControl;

require("./control.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./control.js");